export default {
	title: 'Intereses',
	url: 'intereses',
	no_description: 'Sin objetivo definido',
	context_worse: 'Negativo',
	context_best: 'Positivo',
	tabs: {
		filters: {
			title: 'Filtros de vista'
		},
		general: {
			title: 'General'
		},
		export: {
			title: 'Exportar'
		},
		comments: {
			title: 'Historial'
		},
		bot: {
			title: 'IA'
		}
	},
	messages: {
		edit_stake: 'Edición de interés',
		create_stake: 'Crear un nuevo interés'
	},
	onboarding: {
		title: 'Revisar los intereses',
		description:
			'La IA ha identificado los intereses estructurales de su tema. Verifique que representen realmente lo que podría perder o ganar si no se hace nada. Ajuste, elimine o complete según sea necesario.'
	}
};
